/*
 * Public API Surface of asm
 */
export * from './asm.module';
